var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "homeVideo" }, [
          _vm.videolist.length > 0
            ? _c("div", { staticClass: "home-video marginAuto max1720" }, [
                _c("div", { staticClass: "flexSpace" }, [
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "goto displayIB" },
                    [
                      _c(
                        "vue-link",
                        {
                          attrs: {
                            to: { path: "/caseVideo/0-1-anlishipin.html" }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "more-icon",
                            attrs: { src: _vm.src1, alt: "" }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _c("p", { staticClass: "col666666 home-tlt-fb" }, [
                  _vm._v("即刻加入他们，发现更好的自己！")
                ]),
                _c("div", { staticClass: "flexSpace video-box" }, [
                  _c(
                    "div",
                    { staticClass: "video-left home-video-big" },
                    _vm._l(_vm.videolist, function(item, index) {
                      return index == "0"
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass: "displayIB home-video-big pointEr",
                              on: {
                                click: function($event) {
                                  return _vm.playVideo(
                                    item.videoUrl,
                                    item.title
                                  )
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "positionRE" }, [
                                _c("img", {
                                  class:
                                    index == "0"
                                      ? "homevideo-big-img"
                                      : "homevideo-min-img",
                                  attrs: {
                                    src: _vm.myFun(item.coverImg)
                                      ? _vm.myFun(item.coverImg)
                                      : "",
                                    alt: item.title,
                                    title: ""
                                  }
                                }),
                                _c("img", {
                                  staticClass: "positionAB video-start",
                                  class:
                                    index == "0"
                                      ? "homevideo-big-start"
                                      : "video-min-start",
                                  attrs: {
                                    src: index == "0" ? _vm.src2 : _vm.src3,
                                    alt: "",
                                    title: ""
                                  }
                                })
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "video-title col444444 firstText overflowText"
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "video-right" },
                    _vm._l(_vm.videolist, function(item, index) {
                      return index == "1" || index == "2"
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "video-right-item home-video-min pointEr",
                              on: {
                                click: function($event) {
                                  return _vm.playVideo(
                                    item.videoUrl,
                                    item.title
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "positionRE homevideo-min-box" },
                                [
                                  _c("img", {
                                    staticClass: "homevideo-min-img pointEr",
                                    attrs: {
                                      src: _vm.myFun(item.coverImg)
                                        ? _vm.myFun(item.coverImg)
                                        : "",
                                      alt: item.title,
                                      title: ""
                                    }
                                  }),
                                  _c("img", {
                                    staticClass:
                                      "positionAB video-start video-min-start",
                                    attrs: { src: _vm.src4, alt: "", title: "" }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "video-title col444444 firstText overflowText"
                                },
                                [_vm._v(_vm._s(item.title))]
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ])
              ])
            : _vm._e()
        ])
      : _c("div", { staticClass: "phone-page" }, [
          _vm.videolist.length > 0
            ? _c("div", [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "PhoneVideo-ListBox" },
                  _vm._l(_vm.videolist, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "PhoneVideo-Box",
                        on: {
                          click: function($event) {
                            return _vm.playVideo(item.videoUrl, item.title)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "PhoneVideo-imgBox positionRE" },
                          [
                            _c("img", {
                              staticClass: "PhoneVideo-img",
                              attrs: {
                                src: _vm.httptype(item.coverImg),
                                alt: item.title,
                                title: ""
                              }
                            }),
                            _c("div", {
                              staticClass: "PhoneVideo-play positionAB"
                            })
                          ]
                        ),
                        _c("p", { staticClass: "PhoneVideo-P" }, [
                          _vm._v(_vm._s(item.title))
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "part-title list-tlt displayIB" }, [
      _vm._v("\n          选择脂玫乐 他们已经收获美丽和自信\n          "),
      _c("span", { staticClass: "list-tlt-tip" }, [_vm._v("-")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "PhoneHome-title" }, [
      _vm._v("选择脂玫乐 "),
      _c("span", { staticClass: "col00CDA2" }, [_vm._v("-")]),
      _c("br"),
      _vm._v(" 他们已经收获美丽和健康")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9bb20c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9bb20c6","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/hometest/comPonents/homeVideo/homeVideo.vue
// module id = 971
// module chunks = 1